import { useCallback as g } from "react";
import { checkIsMapLoaded as m } from "./index.es245.js";
import { usePLMapboxStoreV2 as p } from "./index.es6.js";
const f = () => g(({ mapId: e }) => {
  var n, r;
  const t = (r = (n = p.getState().maps) == null ? void 0 : n[e]) == null ? void 0 : r.mapRef;
  if (!t || !m(e)) {
    console.warn("wait for map to be initialized");
    return;
  }
  const o = t.getCenter(), a = t.getZoom(), i = t.getBearing(), c = t.getPitch(), s = t.getPadding();
  return {
    longitude: o.lng,
    latitude: o.lat,
    zoom: a,
    bearing: i,
    pitch: c,
    padding: s
  };
}, []);
export {
  f as useGetViewstate
};
//# sourceMappingURL=index.es195.js.map
